import { useIntl } from '@capsicum/common';
import { Goat } from '@capsicum/common-web';
import styled from 'styled-components';

export const GoatEmptyConsents = () => {
	const { $t } = useIntl();

	return (
		<S.GoatStyle image="ankward" testID="settings-consentsNoConsent">
			<S.GoatTitleContainer>
				<S.GoatTitle>{$t('settings.accountManagement.noConsentsText')}</S.GoatTitle>
			</S.GoatTitleContainer>
		</S.GoatStyle>
	);
};

namespace S {
	export const GoatStyle = styled(Goat)`
		width: 100%;
		padding: ${({ theme }) => theme.spacings.small};
	`;

	export const GoatTitleContainer = styled.div`
		width: 100%;
	`;

	export const GoatTitle = styled.p`
		padding: ${({ theme }) => theme.spacings.small};
		text-align: center;
		${({ theme }) => theme.fonts.text.text4};
	`;
}
